"use client";

import { useState } from "react";

interface FaqItem {
  answer: string;
  question: string;
}

function FaqRow({ item }: { item: FaqItem }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b py-5 last:border-b-0">
      <button
        aria-expanded={open}
        className="flex w-full cursor-pointer items-center justify-between gap-4 text-left"
        onClick={() => setOpen((prev) => !prev)}
        type="button"
      >
        <span className="body-base font-semibold">{item.question}</span>
        <span
          aria-hidden="true"
          className={`shrink-0 text-xl leading-none transition-transform duration-200 ${open ? "rotate-45" : ""}`}
        >
          +
        </span>
      </button>
      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <p className="body-base pt-3 text-muted-foreground">{item.answer}</p>
        </div>
      </div>
    </div>
  );
}

export function FaqAccordion({
  items,
}: {
  items: readonly FaqItem[] | FaqItem[];
}) {
  return (
    <div className="divide-y rounded-xl border bg-card px-6">
      {items.map((item) => (
        <FaqRow item={item} key={item.question} />
      ))}
    </div>
  );
}
